import { useEffect, useState } from 'react';
import { getDelta, transformDataWithFirmColor } from '../../Chart/util';
import { GraphPoint } from '../../generated/graphql';
import { useChartContext } from '../../Chart/context';
import { useGetGraphDataPoints } from '../mutations';
import { useClientContext, useFirmBranding } from '../..';

export interface GraphNetWorthResponse {
  graphNetWorth: GraphPoint[];
}

export const useAccountChart = (groupID: string, householdID: string) => {
  const { rangeFilter } = useChartContext();
  const [graphPoints, setGraphPoints] = useState<GraphPoint[]>([]);
  const dateStart = rangeFilter[0]?.toISOString();
  const dateEnd = rangeFilter[1]?.toISOString();
  const tenantID = householdID;
  const { firmID } = useClientContext();
  const { firmBranding } = useFirmBranding(firmID);

  const { data } = useGetGraphDataPoints({
    tenantID,
    groupID,
    settings: {
      start: dateStart,
      end: dateEnd,
      numberOfPoints: 24,
    },
  });

  useEffect(() => {
    if (data) {
      setGraphPoints(data);
    }
  }, [data]);

  const transformedData = transformDataWithFirmColor(graphPoints, 'firm-color', firmBranding?.color || 'account');
  const delta = getDelta(transformedData);

  return {
    delta,
    transformedData,
  };
};
